import { Trans } from "@lingui/macro";

export const NamePostsPackage = () => <Trans>Post package</Trans>;
